import _ from 'lodash';
import set from 'lodash/fp/set';

const exhibitorsFilter = item => item.is_exhibitor && !item.parent_id;

export default function (state, action) {
    if (!state) {
        state = {
            loaded: false,
            fetchTime: null,
            //
            all: [],
            filter: {
                isActive: false,
                text: '',
                tags: {},
                favorites: false,
            },
            //
            tags: [],
            recommendedFilter: [],
        };
    }

    let previous = state;
    switch (action.type) {
        case 'SINGLE_EVENT_UPDATE':
            state = set(
                'all',
                _([...(action.event.buttons || []), ...(action.event.sponsors || []), ...(state.all || [])])
                    .filter(exhibitorsFilter)
                    .uniqBy('id')
                    .value(),
                state
            );
            break;
        case 'UPDATE_EVENT_SINGLE_DIRECTORY_ITEM':
            state = {
                ...state,
                all: state.all.map(exhibitor => (exhibitor.id == action.item.id ? {...exhibitor, ...action.item} : exhibitor)),
            };
            break;
        case 'UPDATE_EVENT_DIRECTORY_DATA':
            state = {
                ...state,
                all: _([...action.items, ...state.all])
                    .filter(exhibitorsFilter)
                    .uniqBy('id')
                    .value(),
                loaded: true,
                fetchTime: action.fetchTime,
            };
            break;
        case 'EVENT_EXHIBITORS_SET_FILTER_PARAMS':
            state = set('tags', action.tags, state);
            state = set('recommendedFilter', action.recommendedFilter, state);
            break;
        case 'EVENT_EXHIBITORS_SET_FILTER':
            state = set('filter', action.filter, state);
            break;
        case 'EVENT_EXHIBITORS_SET_FILTER_TEXT':
            state = set('filter.text', action.text, state);
            break;
        case 'EVENT_EXHIBITORS_ADD_FILTER_TAG_OPTION':
            state = set(`filter.tags[${action.tag}]`, _.uniq([...(state.filter.tags[action.tag] || []), action.option]), state);
            break;
        case 'EVENT_EXHIBITORS_REMOVE_FILTER_TAG_OPTION':
            state = set(
                `filter.tags[${action.tag}]`,
                _.reject(state.filter.tags[action.tag] || [], option => option == action.option),
                state
            );
            break;
        case 'EVENT_EXHIBITORS_CLEAR_FILTER_TAGS':
            state = set('filter.tags', {}, state);
            break;
        case 'EVENT_EXHIBITORS_CLEAR_FILTER':
            state = set(
                'filter',
                {
                    text: '',
                    tags: {},
                },
                state
            );
            break;
        case 'EVENT_EXHIBITORS_APPLY_RECOMMENDED_FILTER':
            state = set(
                'filter.tags',
                _(state.recommendedFilter).reduce((tags, tag) => {
                    tags[tag.name] = tag.options;
                    return tags;
                }, {}),
                state
            );
            break;
    }

    return state;
}
